export default "/images/ic-lang.svg?1b57c546d7c3c96137b5cf6e8d318e5a";